<template>
  <div>
    <div class="d-flex flex-row">
      <p class="text-h4">
        Cap
      </p>
      <div
        v-if="isCapExceeded"
        class="warning-text text-h6 align-self-center"
      >
        <font-awesome-icon
          :icon="['fas', 'exclamation-triangle']"
        />
        {{ $t('snackbar.cap_exceeded') }}
      </div>
    </div>
    <progress-bar
      :progression-percentage="totalAverageScorePercentage"
      :text="totalAverageScoreRatio"
      size="lg"
      :color="color"
      class="progress-bar"
    />
    <div
      v-if="!isLineupComplete && !isCapExceeded"
    >
      {{ $t('lineup_header.average_per_free_position') }}
      <average-score
        :average-score="averagePositionFree"
      />
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar.vue';
import gameWeek from '@/models/GameWeek/gameWeek';
import lineup from '@/models/Lineup/lineup';
import AverageScore from '@/components/Card/AverageScore.vue';

export default {
  name: 'Cap',
  components: {
    ProgressBar,
    AverageScore,
  },
  props: {
    cap: {
      type: Number,
      required: true,
    },
    players: {
      type: Array,
      default() {
        return [];
      },
    },
    gameWeek: {
      type: gameWeek,
      default() {
        return {};
      },
    },
    lineup: {
      type: lineup,
      default() {
        return {};
      },
    },
    maxPlayer: {
      type : Number,
      required : true,
    }
  },
  computed: {
    isGameWeekOpen() {
      return this.gameWeek.isOpen();
    },
    totalAverageScore() {
      let totalAverageScore = 0;
      this.isGameWeekOpen
        ? this.players.forEach((player) => {
          totalAverageScore += player.last15Average;
        })
        : totalAverageScore = this.lineup.averageScoreSum;
      return totalAverageScore;
    },
    totalAverageScoreRatio() {
      return this.isGameWeekOpen
             ? `${this.totalAverageScore}/${this.cap}`
             : `${this.lineup.averageScoreSum}/${this.cap}`;
    },
    totalAverageScorePercentage() {
      return this.isGameWeekOpen
             ? (this.totalAverageScore * 100) / this.cap
             : (this.lineup.averageScoreSum * 100) / this.cap;
    },
    isCapExceeded() {
      return this.totalAverageScore > this.cap;
    },
    color() {
      return this.isCapExceeded ? '#D32F2F' : '#8992b2';
    },
    averagePositionFree() {
        return (this.cap - this.totalAverageScore) / this.countEmptySlots
    },
    countEmptySlots() {
      const cards = this.lineup.getCards();
      return this.maxPlayer - cards.length;
    },
    isLineupComplete(){
      return this.countEmptySlots === 0;
    }
  },
};
</script>

<style scoped lang="scss">
.component {
  background-color: transparent;
}

.progress-bar {
  width: 100%;
}

.warning-text {
  color: $error;
  margin-left: 20px;
}
</style>
